
// ─── ROW ────────────────────────────────────────────────────────────────────

import PreguntaConfirmacionPlantelActions from "./Preguntaconfirmacionplantelactions";

export const PreguntaConfirmacionPlantelRow = ({ pregunta, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{pregunta.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(pregunta.pregunta || "-"),
        }}
      />
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            pregunta.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {pregunta.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        {pregunta.created_at
          ? new Date(pregunta.created_at).toLocaleDateString("es-MX", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-"}
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <PreguntaConfirmacionPlantelActions pregunta={pregunta} />
        </span>
      </td>
    </tr>
  );
};

// ─── TABLE ───────────────────────────────────────────────────────────────────

const PreguntasConfirmacionPlantelTable = ({ preguntas, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Pregunta</th>
            <th>Estado</th>
            <th>Fecha creación</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {preguntas.map((pregunta) => (
            <PreguntaConfirmacionPlantelRow
              key={pregunta.id}
              pregunta={pregunta}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PreguntasConfirmacionPlantelTable;
